import { datadogRum } from '@datadog/browser-rum'
import { useAtom } from 'jotai'
import { useCallback } from 'react'
import { ChangeSsnWarningDialog } from '@/components/ChangeSsnWarningDialog/ChangeSsnWarningDialog'
import { useShopSessionId } from '@/services/shopSession/ShopSessionContext'
import { usePriceCalculatorStep } from '../../usePriceCalculatorStep'
import { priceCalculatorShowEditSsnWarningAtom } from '../priceCalculatorAtoms'

export function EditSsnWarningContainer() {
  const { setStep } = usePriceCalculatorStep()
  const [isVisible, setVisible] = useAtom(priceCalculatorShowEditSsnWarningAtom)
  const shopSessionId = useShopSessionId()

  const handleAccept = useCallback(() => {
    datadogRum.addAction('Cleared shopSession to change SSN in price calculator', {
      shopSessionId,
    })

    setStep('loadingForm')
    setVisible(false)
  }, [shopSessionId, setStep, setVisible])

  const handleDecline = () => setVisible(false)
  return <ChangeSsnWarningDialog open={isVisible} onDecline={handleDecline} onAccept={handleAccept} />
}
